import { isValidFilterConfig } from "../../../utilities/commonUtilities";
import i18n from "../../../utilities/i18n";
/**
 * report type that need to show on the selectbox
 */
export const ReportDropDownType = [
    {"id": 1, "name": 'Transaction'},
    {"id": 2, "name": 'Charges/Debit'},
    {"id": 3, "name": 'Claim Level'},
    {"id": 4, "name": 'Payment/Adjustment'},
    {"id": 5, "name": 'Open AR'},
    {"id": 6, "name": 'Check Level'},
    {"id": 7, "name": 'Denial'},
    {"id": 8, "name": 'Prior Authorization/Referral'},
    {"id": 9, "name": 'Insurance Credit Balance Report'},
    {"id":10, "name": 'Pre-Billing Productivity Report'}
]

export const reportStatusType=[
    {"id": 1, "name": 'In Progress'},
    {"id": 2, "name": 'Failed'},
    {"id": 3, "name": 'Completed'},
]

/*********************Filter configuration of all filters******************************** */
export const chargeDebitFilterConfig = [
    {
        fieldName: "date_of_service_from",
        type: "dateField",
        label: i18n.t("reports.filters.dateOfServiceFrom"),
    },
    {
        fieldName: "date_of_service_to",
        type: "dateField",
        label: i18n.t("reports.filters.dateOfServiceTo"),
        minDateField: "date_of_service_from"
    },
    {
        fieldName: "date_of_entry_from",
        type: "dateField",
        label: i18n.t("reports.filters.dateOfEntryFrom")
    },
    {
        fieldName: "date_of_entry_to",
        type: "dateField",
        label: i18n.t("reports.filters.dateOfEntryTo"),
        minDateField: "date_of_entry_from"
    },
    {
        fieldName: "first_billed_date_from",
        type: "dateField",
        label: i18n.t("reports.filters.firstBilledDateFrom")
    },
    {
        fieldName: "first_billed_date_to",
        type: "dateField",
        label: i18n.t("reports.filters.firstBilledDateTo"),
        minDateField: "first_billed_date_from"
    },
    {
        fieldName: "last_billed_date_from",
        type: "dateField",
        label: i18n.t("reports.filters.lastBilledDateFrom")
    },
    {
        fieldName: "last_billed_date_to",
        type: "dateField",
        label: i18n.t("reports.filters.lastBilledDateTo"),
        minDateField: "last_billed_date_from"
    },
    {
        fieldName: 'sample_received_date_from',
        label: i18n.t("reports.filters.sampleReceivedDateFrom"),
        type: 'dateField',
    },
    {
        fieldName: 'sample_received_date_to',
        label: i18n.t("reports.filters.sampleReceivedDateTo"),
        type: 'dateField',
        minDateField: "sample_received_date_from"
    },
    {
        fieldName: "payer_type",
        type: "multiSelect",
        label: i18n.t("reports.filters.payerType"),
        dropDownOptionName: "payerTypes"
    },
    {
        fieldName: "insurance_company",
        type: "multiSelect",
        label: i18n.t("reports.filters.insuranceCompanies"),
        dropDownOptionName: "insuranceCompanyList"
    },
    {
        fieldName: "claim_status",
        type: "multiSelect",
        label: i18n.t("reports.filters.claimStatus"),
        dropDownOptionName: "claimStatusList"
    },
    {
        fieldName: "claim_sub_status",
        type: "multiSelect",
        label: i18n.t("reports.filters.claimSubStatus"),
        dropDownOptionName: "claimSubStatusList"
    },
    {
        fieldName: "rendering_provider",
        type: "multiSelect",
        label: i18n.t("reports.filters.renderingProvider"),
        dropDownOptionName: "renderingProviderList"
    },
    {
        fieldName: "reffering_provider",
        type: "multiSelect",
        label: i18n.t("reports.filters.refferingProvider"),
        dropDownOptionName: "referringProviderList"
    },
    {
        fieldName: "billing_provider",
        type: "multiSelect",
        label: i18n.t("reports.filters.billingProvider"),
        dropDownOptionName: "renderingProviderList"
    },
    {
        fieldName: "service_locations",
        type: "multiSelect",
        label: i18n.t("reports.filters.serviceLocation"),
        dropDownOptionName: "serviceLocationList"
    },
    {
        fieldName: "cpt_code",
        type: "multiSelect",
        label: i18n.t("reports.filters.cptList"),
        dropDownOptionName: "cptList"
    },
    {
        fieldName: "icd",
        type: "multiSelect",
        label: i18n.t("reports.filters.ICD"),
        dropDownOptionName: "icdList"
    },
    {
        fieldName: "charge_enter_user",
        type: "multiSelect",
        label: i18n.t("reports.filters.chargeEntered"),
        dropDownOptionName: "praticeUserList"
    },
    {
        fieldName: "payment_enter_user",
        type: "multiSelect",
        label: i18n.t("reports.filters.paymentEntered"),
        dropDownOptionName: "praticeUserList"
    },
    {
        fieldName: "aging",
        type: "select",
        label: i18n.t("reports.filters.aging"),
        dropDownOptionName: "agingList"
    },
    {
        fieldName: "lab_sales_rep",
        type: "text",
        label: i18n.t("reports.filters.labSalesRep")
    },
    {
        fieldName: "clinic_site_name",
        type: "text",
        label: i18n.t("reports.filters.clinicSiteName")
    },
    {
        fieldName: "claim_service_type",
        type: "text",
        label: i18n.t("reports.filters.claimServiceType")
    },
    {
        fieldName: 'balance_type',
        label: i18n.t("reports.filters.balanceAmountTotals"),
        type: 'amountFilter',
        fieldPrefix: 'balanceAmountTotals',
    }

];

export const paymentAdjustmentsFilterConfig = [
    {
        fieldName: "date_of_service_from",
        type: "dateField",
        label: i18n.t("reports.filters.dateOfServiceFrom"),
    },
    {
        fieldName: "date_of_service_to",
        type: "dateField",
        label: i18n.t("reports.filters.dateOfServiceTo"),
        minDateField: "date_of_service_from"
    },
    {
        fieldName: "date_of_entry_from",
        type: "dateField",
        label: i18n.t("reports.filters.dateOfEntryFrom")
    },
    {
        fieldName: "date_of_entry_to",
        type: "dateField",
        label: i18n.t("reports.filters.dateOfEntryTo"),
        minDateField: "date_of_entry_from"
    },
    {
        fieldName: "first_billed_date_from",
        type: "dateField",
        label: i18n.t("reports.filters.firstBilledDateFrom"),
    },
    {
        fieldName: "first_billed_date_to",
        type: "dateField",
        label: i18n.t("reports.filters.firstBilledDateTo"),
        minDateField: "first_billed_date_from"
    },
    {
        fieldName: "last_billed_date_from",
        type: "dateField",
        label: i18n.t("reports.filters.lastBilledDateFrom"),
    },
    {
        fieldName: "last_billed_date_to",
        type: "dateField",
        label: i18n.t("reports.filters.lastBilledDateTo"),
        minDateField: "last_billed_date_from"
    },
    {
        fieldName: 'sample_received_date_from',
        label: i18n.t("reports.filters.sampleReceivedDateFrom"),
        type: 'dateField',
    },
    {
        fieldName: 'sample_received_date_to',
        label: i18n.t("reports.filters.sampleReceivedDateTo"),
        type: 'dateField',
        minDateField: "sample_received_date_from"
    },
    {
        fieldName: "payer_type",
        type: "multiSelect",
        label: i18n.t("reports.filters.payerType"),
        dropDownOptionName: "payerTypes"
    },
    {
        fieldName: "insurance_company",
        type: "multiSelect",
        label: i18n.t("reports.filters.insuranceCompanies"),
        dropDownOptionName: "insuranceCompanyList"
    },
    {
        fieldName: "claim_status",
        type: "multiSelect",
        label: i18n.t("reports.filters.claimStatus"),
        dropDownOptionName: "claimStatusList"
    },
    {
        fieldName: "claim_sub_status",
        type: "multiSelect",
        label: i18n.t("reports.filters.claimSubStatus"),
        dropDownOptionName: "claimSubStatusList"
    },
    {
        fieldName: "rendering_provider",
        type: "multiSelect",
        label: i18n.t("reports.filters.renderingProvider"),
        dropDownOptionName: "renderingProviderList"
    },
    {
        fieldName: "reffering_provider",
        type: "multiSelect",
        label: i18n.t("reports.filters.refferingProvider"),
        dropDownOptionName: "referringProviderList"
    },
    {
        fieldName: "billing_provider",
        type: "multiSelect",
        label: i18n.t("reports.filters.billingProvider"),
        dropDownOptionName: "renderingProviderList"
    },
    {
        fieldName: "service_locations",
        type: "multiSelect",
        label: i18n.t("reports.filters.serviceLocation"),
        dropDownOptionName: "serviceLocationList"
    },
    {
        fieldName: "cpt_code",
        type: "multiSelect",
        label: i18n.t("reports.filters.cptList"),
        dropDownOptionName: "cptList"
    },
    {
        fieldName: "icd",
        type: "multiSelect",
        label: i18n.t("reports.filters.ICD"),
        dropDownOptionName: "icdList"
    },
    {
        fieldName: "charge_enter_user",
        type: "multiSelect",
        label: i18n.t("reports.filters.chargeEntered"),
        dropDownOptionName: "praticeUserList"
    },
    {
        fieldName: "payment_enter_user",
        type: "multiSelect",
        label: i18n.t("reports.filters.paymentEntered"),
        dropDownOptionName: "praticeUserList"
    },
    {
        fieldName: "date_of_payment_entry_from",
        type: "dateField",
        label: i18n.t("reports.filters.dateOfPaymentEntryFrom"),
    },
    {
        fieldName: "date_of_payment_entry_to",
        type: "dateField",
        label: i18n.t("reports.filters.dateOfPaymentEntryTo"),
        minDateField: "date_of_payment_entry_from"
    },
    {
        fieldName: "payment_check_date_from",
        type: "dateField",
        label: i18n.t("reports.filters.paymentCheckDateFrom"),
    },
    {
        fieldName: "payment_check_date_to",
        type: "dateField",
        label: i18n.t("reports.filters.paymentCheckDateTo"),
        minDateField: "payment_check_date_from"
    },
    {
        fieldName: "payment_check_number",
        type: "text",
        label: i18n.t("reports.filters.paymentCheckNumber")
    },
    {
        fieldName: "aging",
        type: "select",
        label: i18n.t("reports.filters.aging"),
        dropDownOptionName: 'agingList'
    },
    {
        fieldName: "lab_sales_rep",
        type: "text",
        label: i18n.t("reports.filters.labSalesRep")
    },
    {
        fieldName: "clinic_site_name",
        type: "text",
        label: i18n.t("reports.filters.clinicSiteName")
    },
    {
        fieldName: 'balance_type',
        label: i18n.t("reports.filters.balanceAmountTotals"),
        type: 'amountFilter',
        fieldPrefix: 'balanceAmountTotals',
    },
    {
        fieldName: "claim_service_type",
        type: "text",
        label: i18n.t("reports.filters.claimServiceType")
    }
].map(item => {
    if (!isValidFilterConfig(item)) {
        throw new Error(`Invalid filter config for ${item.fieldName}`);
    }
    return item;
})

export const openArFilterConfig = [
    {
        fieldName: 'date_of_service_from',
        label: i18n.t("reports.filters.dateOfServiceFrom"),
        type: 'dateField',
    },
    {
        fieldName: 'date_of_service_to',
        label: i18n.t("reports.filters.dateOfServiceTo"),
        type: 'dateField',
        minDateField: "date_of_service_from"
    },
    {
        fieldName: 'date_of_entry_from',
        label: i18n.t("reports.filters.dateOfEntryFrom"),
        type: 'dateField'
    },
    {
        fieldName: 'date_of_entry_to',
        label: i18n.t("reports.filters.dateOfEntryTo"),
        type: 'dateField',
        minDateField: "date_of_entry_from"
    },
    {
        fieldName: 'first_billed_date_from',
        label: i18n.t("reports.filters.firstBilledDateFrom"),
        type: 'dateField'
    },
    {
        fieldName: 'first_billed_date_to',
        label: i18n.t("reports.filters.firstBilledDateTo"),
        type: 'dateField',
        minDateField: "first_billed_date_from"
    },
    {
        fieldName: 'last_billed_date_from',
        label: i18n.t("reports.filters.lastBilledDateFrom"),
        type: 'dateField'
    },
    {
        fieldName: 'last_billed_date_to',
        label: i18n.t("reports.filters.lastBilledDateTo"),
        type: 'dateField',
        minDateField: "last_billed_date_from"
    },
    {
        fieldName: 'sample_received_date_from',
        label: i18n.t("reports.filters.sampleReceivedDateFrom"),
        type: 'dateField',
    },
    {
        fieldName: 'sample_received_date_to',
        label: i18n.t("reports.filters.sampleReceivedDateTo"),
        type: 'dateField',
        minDateField: "sample_received_date_from"
    },
    {
        fieldName: 'payer_type',
        label: i18n.t("reports.filters.payerType"),
        type: 'multiSelect',
        dropDownOptionName: 'payerTypes'
    },
    {
        fieldName: 'insurance_company',
        label: i18n.t("reports.filters.insuranceCompanies"),
        type: 'multiSelect',
        dropDownOptionName: 'insuranceCompanyList'
    },
    {
        fieldName: 'claim_status',
        label: i18n.t("reports.filters.claimStatus"),
        type: 'multiSelect',
        dropDownOptionName: 'claimStatusList'
    },
    {
        fieldName: 'claim_sub_status',
        label: i18n.t("reports.filters.claimSubStatus"),
        type: 'multiSelect',
        dropDownOptionName: 'claimSubStatusList'
    },
    {
        fieldName: 'rendering_provider',
        label: i18n.t("reports.filters.renderingProvider"),
        type: 'multiSelect',
        dropDownOptionName: 'renderingProviderList'
    },
    {
        fieldName: 'reffering_provider',
        label: i18n.t("reports.filters.refferingProvider"),
        type: 'multiSelect',
        dropDownOptionName: 'referringProviderList'
    },
    {
        fieldName: 'billing_provider',
        label: i18n.t("reports.filters.billingProvider"),
        type: 'multiSelect',
        dropDownOptionName: 'renderingProviderList'
    },
    {
        fieldName: 'service_locations',
        label: i18n.t("reports.filters.serviceLocation"),
        type: 'multiSelect',
        dropDownOptionName: 'serviceLocationList'
    },
    {
        fieldName: 'cpt_code',
        label: i18n.t("reports.filters.cptList"),
        type: 'multiSelect',
        dropDownOptionName: 'cptList'
    },
    {
        fieldName: 'icd',
        label: i18n.t("reports.filters.ICD"),
        type: 'multiSelect',
        dropDownOptionName: 'icdList'
    },
    {
        fieldName: 'aging',
        label: i18n.t("reports.filters.aging"),
        type: 'select',
        dropDownOptionName: 'agingList'
    },
    {
        fieldName: "lab_sales_rep",
        type: "text",
        label: i18n.t("reports.filters.labSalesRep")
    },
    {
        fieldName: "clinic_site_name",
        type: "text",
        label: i18n.t("reports.filters.clinicSiteName")
    },
    {
        fieldName: "claim_service_type",
        type: "text",
        label: i18n.t("reports.filters.claimServiceType")
    },
    {
        fieldName: 'balance_type',
        label: i18n.t("reports.filters.balanceAmountTotals"),
        type: 'amountFilter',
        fieldPrefix: 'balanceAmountTotals',
    }
].map(item => {
    if (!isValidFilterConfig(item)) {
        throw new Error(`Invalid filter config for ${item.fieldName}`);
    }
    return item;
})


export const transactionFilterConfig = [
    {
        fieldName: 'date_of_service_from',
        label: i18n.t("reports.filters.dateOfServiceFrom"),
        type: 'dateField',
        columnWidth: 'col-3' // optional, report filter component will take col-3 as default
    },
    {
        fieldName: 'date_of_service_to',
        label: i18n.t("reports.filters.dateOfServiceTo"),
        type: 'dateField',
        minDateField: "date_of_service_from"
    },
    {
        fieldName: 'transaction_from',
        label: i18n.t("reports.filters.transactionFrom"),
        type: 'dateField',
    },
    {
        fieldName: 'transaction_to',
        label: i18n.t("reports.filters.transactionTo"),
        type: 'dateField',
        minDateField: "transaction_from"
    },
    {
        fieldName: 'first_billed_date_from',
        label: i18n.t("reports.filters.firstBilledDateFrom"),
        type: 'dateField',
    },
    {
        fieldName: 'first_billed_date_to',
        label: i18n.t("reports.filters.firstBilledDateTo"),
        type: 'dateField',
        minDateField: "first_billed_date_from"
    },
    {
        fieldName: 'last_billed_date_from',
        label: i18n.t("reports.filters.lastBilledDateFrom"),
        type: 'dateField',
    },
    {
        fieldName: 'last_billed_date_to',
        label: i18n.t("reports.filters.lastBilledDateTo"),
        type: 'dateField',
        minDateField: "last_billed_date_from"
    },
    {
        fieldName: 'sample_received_date_from',
        label: i18n.t("reports.filters.sampleReceivedDateFrom"),
        type: 'dateField',
    },
    {
        fieldName: 'sample_received_date_to',
        label: i18n.t("reports.filters.sampleReceivedDateTo"),
        type: 'dateField',
        minDateField: "sample_received_date_from"
    },
    {
        fieldName: 'patient_ids',
        label: i18n.t("reports.filters.patientId"),
        type: 'multiSearchSelect',
        dropDownOptionName: 'patientIdList',
    },
    {
        fieldName: 'payer_type',
        label: i18n.t("reports.filters.payerType"),
        type: 'multiSelect',
        dropDownOptionName: 'payerTypes'
    },
    {
        fieldName: 'insurance_company',
        label: i18n.t("reports.filters.insuranceCompanies"),
        type: 'multiSelect',
        dropDownOptionName: 'insuranceCompanyList'
    },
    {
        fieldName: 'claim_status',
        label: i18n.t("reports.filters.claimStatus"),
        type: 'multiSelect',
        dropDownOptionName: 'claimStatusList'
    },
    {
        fieldName: 'claim_sub_status',
        label: i18n.t("reports.filters.claimSubStatus"),
        type: 'multiSelect',
        dropDownOptionName: 'claimSubStatusList'
    },
    {
        fieldName: 'rendering_provider',
        label: i18n.t("reports.filters.renderingProvider"),
        type: 'multiSelect',
        dropDownOptionName: 'renderingProviderList'
    },
    {
        fieldName: 'reffering_provider',
        label: i18n.t("reports.filters.refferingProvider"),
        type: 'multiSelect',
        dropDownOptionName: 'referringProviderList'
    },
    {
        fieldName: 'billing_provider',
        label: i18n.t("reports.filters.billingProvider"),
        type: 'multiSelect',
        dropDownOptionName: 'renderingProviderList'
    },
    {
        fieldName: 'service_locations',
        label: i18n.t("reports.filters.serviceLocation"),
        type: 'multiSelect',
        dropDownOptionName: 'serviceLocationList'
    },
    {
        fieldName: 'cpt_code',
        label: i18n.t("reports.filters.cptList"),
        type: 'multiSelect',
        dropDownOptionName: 'cptList'
    },
    {
        fieldName: 'icd',
        label: i18n.t("reports.filters.ICD"),
        type: 'multiSelect',
        dropDownOptionName: 'icdList'
    },
    {
        fieldName: 'transaction_entered_by_user',
        label: i18n.t("reports.filters.transactionEnteredUser"),
        type: 'multiSelect',
        dropDownOptionName: 'praticeUserList'
    },
    {
        fieldName: 'transaction_type',
        label: i18n.t("reports.filters.transaction_type"),
        type: 'multiSelect',
        dropDownOptionName: 'transactionTypes'
    },
    {
        fieldName: 'aging',
        label: i18n.t("reports.filters.aging"),
        type: 'select',
        dropDownOptionName: 'agingList'
    },
    {
        fieldName: "lab_sales_rep",
        type: "text",
        label: i18n.t("reports.filters.labSalesRep")
    },
    {
        fieldName: "clinic_site_name",
        type: "text",
        label: i18n.t("reports.filters.clinicSiteName")
    },
    {
        fieldName: 'balance_type',
        label: i18n.t("reports.filters.balanceAmountTotals"),
        type: 'amountFilter',
        fieldPrefix: 'balanceAmountTotals',
    },
    {
        fieldName: "claim_service_type",
        type: "text",
        label: i18n.t("reports.filters.claimServiceType")
    },

].map(item => {
    if (!isValidFilterConfig(item)) {
        throw new Error(`Invalid filter config for ${item.fieldName}`);
    }
    return item;
})

export const checkLevelFilterConfig = [
    {
        fieldName: "payment_check_date_from",
        type: "dateField",
        label: i18n.t("reports.filters.paymentCheckDateFrom")
    },
    {
        fieldName: "payment_check_date_to",
        type: "dateField",
        label: i18n.t("reports.filters.paymentCheckDateTo"),
        minDateField: "payment_check_date_from"
    },
    {
        fieldName: "payment_entered_date_from",
        type: "dateField",
        label: i18n.t("reports.paymt_entered_dateRange_from")
    },
    {
        fieldName: "payment_entered_date_to",
        type: "dateField",
        label: i18n.t("reports.paymt_entered_dateRange_to"),
        minDateField: "payment_entered_date_from"
    },
    {
        fieldName: "payment_modes",
        type: "multiSelect",
        label: i18n.t("reports.payment_mode"),
        dropDownOptionName: "paymentModes"
    },
    {
        fieldName: "insurance_payer_ids",
        type: "multiSelect",
        label: i18n.t("reports.payt_from_insurance"),
        dropDownOptionName: "paymentPayerList"
    },
    {
        fieldName: "adjustment_type_ids",
        type: "multiSelect",
        label: i18n.t("reports.payment_level_adjustment"),
        dropDownOptionName: "paymentAdjustmentTypesList"
    },
    {
        fieldName: "claim_service_type",
        type: "text",
        label: i18n.t("reports.filters.claimServiceType")
    },
    {
        fieldName: "lab_sales_rep",
        type: "text",
        label: i18n.t("reports.filters.labSalesRep")
    },
    {
        fieldName: "clinic_site_name",
        type: "text",
        label: i18n.t("reports.filters.clinicSiteName")
    },
    {
        fieldName: 'level_adjustment_amount',
        label: 'Level Adjustment Amount',
        type: 'amountFilter',
        fieldPrefix: 'level_adjustment'
    },
    {
        fieldName: 'applied_amount',
        label: 'Applied Amount',
        type: 'amountFilter',
        fieldPrefix: 'applied_amount',
    },
    {
        fieldName: 'unApplied_amount',
        label: 'Un-Applied Amount',
        type: 'amountFilter',
        fieldPrefix: 'unapplied_amount',
    }
].map(item => {
    if (!isValidFilterConfig(item)) {
        throw new Error(`Invalid filter config for ${item.fieldName}`);
    }
    return item;
})

export const priorAuthFilterConfig = [
    {
        fieldName: "valid_auth_from",
        type: "dateField",
        label: i18n.t("reports.filters.validAuthFrom")
    },
    {
        fieldName: "valid_auth_to",
        type: "dateField",
        label: i18n.t("reports.filters.validAuthTo"),
        minDateField: "valid_auth_from"
    },
    {
        fieldName: "visit_remaining_min",
        type: "text",
        label: i18n.t("reports.filters.visitRemainingMin"),
    },
    {
        fieldName: "visit_remaining_max",
        type: "text",
        label: i18n.t("reports.filters.visitRemainingMax"),
    },
    {
        fieldName: "insurance_company",
        type: "multiSelect",
        label: i18n.t("reports.filters.insuranceCompanies"),
        dropDownOptionName: "insuranceCompanyList"
    },
    {
        fieldName: 'patient_ids',
        label: i18n.t("reports.filters.patientSearch"),
        type: 'multiSearchSelect',
        dropDownOptionName: 'patientIdList',
    },
    {
        fieldName: 'cpt_code',
        label: i18n.t("reports.filters.cptList"),
        type: 'multiSelect',
        dropDownOptionName: 'cptList'
    },
    {
        fieldName: 'icd',
        label: i18n.t("reports.filters.ICD"),
        type: 'multiSelect',
        dropDownOptionName: 'icdList'
    },
].map(item => {
    if (!isValidFilterConfig(item)) {
        throw new Error(`Invalid filter config for ${item.fieldName}`);
    }
    return item;
})

export const denialFilterConfig = [
    // Date of Service Range
    {
        fieldName: "date_of_service_from",
        type: "dateField",
        label: i18n.t("reports.filters.dateOfServiceFrom")
    },
    {
        fieldName: "date_of_service_to",
        type: "dateField",
        label: i18n.t("reports.filters.dateOfServiceTo"),
        minDateField: "date_of_service_from"
    },

    // Payment Entry Date Range
    {
        fieldName: "date_of_payment_entry_from",
        type: "dateField",
        label: i18n.t("reports.filters.dateOfPaymentEntryFrom")
    },
    {
        fieldName: "date_of_payment_entry_to",
        type: "dateField",
        label: i18n.t("reports.filters.dateOfPaymentEntryTo"),
        minDateField: "date_of_payment_entry_from"
    },

    // Claim Entry Date Range
    {
        fieldName: "date_of_entry_from",
        type: "dateField",
        label: i18n.t("reports.filters.dateOfEntryFrom")
    },
    {
        fieldName: "date_of_entry_to",
        type: "dateField",
        label: i18n.t("reports.filters.dateOfEntryTo"),
        minDateField: "date_of_entry_from"
    },

    // Check Date Range
    {
        fieldName: "payment_check_date_from",
        type: "dateField",
        label: i18n.t("reports.filters.paymentCheckDateFrom")
    },
    {
        fieldName: "payment_check_date_to",
        type: "dateField",
        label: i18n.t("reports.filters.paymentCheckDateTo"),
        minDateField: "payment_check_date_from"
    },

    // First Billed Date Range
    {
        fieldName: "first_billed_date_from",
        type: "dateField",
        label: i18n.t("reports.filters.firstBilledDateFrom")
    },
    {
        fieldName: "first_billed_date_to",
        type: "dateField",
        label: i18n.t("reports.filters.firstBilledDateTo"),
        minDateField: "first_billed_date_from"
    },

    // Last Billed Date Range
    {
        fieldName: "last_billed_date_from",
        type: "dateField",
        label: i18n.t("reports.filters.lastBilledDateFrom")
    },
    {
        fieldName: "last_billed_date_to",
        type: "dateField",
        label: i18n.t("reports.filters.lastBilledDateTo"),
        minDateField: "last_billed_date_from"
    },
    {
        fieldName: 'sample_received_date_from',
        label: i18n.t("reports.filters.sampleReceivedDateFrom"),
        type: 'dateField',
    },
    {
        fieldName: 'sample_received_date_to',
        label: i18n.t("reports.filters.sampleReceivedDateTo"),
        type: 'dateField',
        minDateField: "sample_received_date_from"
    },

    // Multi-Select Lists
    {
        fieldName: "insurance_company",
        type: "multiSelect",
        label: i18n.t("reports.filters.insuranceCompanies"),
        dropDownOptionName: "insuranceCompanyList"
    },
    {
        fieldName: "claim_status",
        type: "multiSelect",
        label: i18n.t("reports.filters.claimStatus"),
        dropDownOptionName: "claimStatusList"
    },
    {
        fieldName: "claim_sub_status",
        type: "multiSelect",
        label: i18n.t("reports.filters.claimSubStatus"),
        dropDownOptionName: "claimSubStatusList"
    },
    {
        fieldName: "rendering_provider",
        type: "multiSelect",
        label: i18n.t("reports.filters.renderingProvider"),
        dropDownOptionName: "renderingProviderList"
    },
    {
        fieldName: "reffering_provider",
        type: "multiSelect",
        label: i18n.t("reports.refferingProvider"),
        dropDownOptionName: "referringProviderList"
    },
    {
        fieldName: "billing_provider",
        type: "multiSelect",
        label: i18n.t("reports.filters.billingProvider"),
        dropDownOptionName: "renderingProviderList"
    },
    {
        fieldName: "cpt_code",
        type: "multiSelect",
        label: i18n.t("reports.filters.cptList"),
        dropDownOptionName: "cptList"
    },
    {
        fieldName: "denial_code",
        type: "multiSearchSelect",
        label: i18n.t("reports.filters.adjustmentCodes"),
        dropDownOptionName: "adjustmentCodesList"
    },
    {
        fieldName: "service_locations",
        type: "multiSelect",
        label: i18n.t("reports.filters.serviceLocation"),
        dropDownOptionName: "serviceLocationList"
    },
    {
        fieldName: "aging",
        type: "select",
        label: i18n.t("reports.filters.aging"),
        dropDownOptionName: "agingList"
    },
    // Text input
    {
        fieldName: "lab_sales_rep",
        type: "text",
        label: i18n.t("reports.filters.labSalesRep")
    },
    {
        fieldName: "clinic_site_name",
        type: "text",
        label: i18n.t("reports.filters.clinicSiteName")
    },
    {
        fieldName: "charge_amount",
        type: "amountFilter",
        label: i18n.t("reports.cpt_charge_amount"),
        fieldPrefix: "charge_amount"
    },
    

    // Amount Range Filters
    {
        fieldName: "balance_type",
        type: "amountFilter",
        label: i18n.t("reports.filters.balanceAmountTotals"),
        fieldPrefix: "balanceAmountTotals"
    },
    
    {
        fieldName: "claim_service_type",
        type: "text",
        label: i18n.t("reports.filters.claimServiceType")
    }
].map(item => {
    if (!isValidFilterConfig(item)) {
        throw new Error(`Invalid filter config for ${item.fieldName}`);
    }
    return item;
})

export const claimlevelFilterConfig = [
    {
        fieldName: "date_of_service_from",
        type: "dateField",
        label: i18n.t("reports.filters.dateOfServiceFrom")
    },
    {
        fieldName: "date_of_service_to",
        type: "dateField",
        label: i18n.t("reports.filters.dateOfServiceTo"),
        minDateField: "date_of_service_from"
    },

    {
        fieldName: "first_billed_date_from",
        type: "dateField",
        label: i18n.t("reports.filters.firstBilledDateFrom")
    },
    {
        fieldName: "first_billed_date_to",
        type: "dateField",
        label: i18n.t("reports.filters.firstBilledDateTo"),
        minDateField: "first_billed_date_from"
    },

    {
        fieldName: "last_billed_date_from",
        type: "dateField",
        label: i18n.t("reports.filters.lastBilledDateFrom")
    },
    {
        fieldName: "last_billed_date_to",
        type: "dateField",
        label: i18n.t("reports.filters.lastBilledDateTo"),
        minDateField: "last_billed_date_from"
    },
    {
        fieldName: 'sample_received_date_from',
        label: i18n.t("reports.filters.sampleReceivedDateFrom"),
        type: 'dateField',
    },
    {
        fieldName: 'sample_received_date_to',
        label: i18n.t("reports.filters.sampleReceivedDateTo"),
        type: 'dateField',
        minDateField: "sample_received_date_from"
    },
    {
        fieldName: 'patient_ids',
        label: i18n.t("reports.filters.patientId"),
        type: 'multiSearchSelect',
        dropDownOptionName: 'patientIdList',
    },

    {
        fieldName: 'payer_type',
        label: i18n.t("reports.filters.payerType"),
        type: 'multiSelect',
        dropDownOptionName: 'payerTypes'
    },

    {
        fieldName: 'insurance_company',
        label: i18n.t("reports.filters.insuranceCompanies"),
        type: 'multiSelect',
        dropDownOptionName: 'insuranceCompanyList'
    },

    {
        fieldName: 'claim_status',
        label: i18n.t("reports.filters.claimStatus"),
        type: 'multiSelect',
        dropDownOptionName: 'claimStatusList'
    },
    {
        fieldName: 'claim_sub_status',
        label: i18n.t("reports.filters.claimSubStatus"),
        type: 'multiSelect',
        dropDownOptionName: 'claimSubStatusList'
    },
    {
        fieldName: 'rendering_provider',
        label: i18n.t("reports.filters.renderingProvider"),
        type: 'multiSelect',
        dropDownOptionName: 'renderingProviderList'
    },
    {
        fieldName: 'reffering_provider',
        label: i18n.t("reports.filters.refferingProvider"),
        type: 'multiSelect',
        dropDownOptionName: 'referringProviderList'
    },
    {
        fieldName: 'billing_provider',
        label: i18n.t("reports.filters.billingProvider"),
        type: 'multiSelect',
        dropDownOptionName: 'renderingProviderList'
    },
    {
        fieldName: 'service_locations',
        label: i18n.t("reports.filters.serviceLocation"),
        type: 'multiSelect',
        dropDownOptionName: 'serviceLocationList'
    },
    {
        fieldName: 'cpt_code',
        label: i18n.t("reports.filters.cptList"),
        type: 'multiSelect',
        dropDownOptionName: 'cptList'
    },
    {
        fieldName: 'icd',
        label: i18n.t("reports.filters.ICD"),
        type: 'multiSelect',
        dropDownOptionName: 'icdList'
    },
    {
        fieldName: 'transaction_from',
        label: i18n.t("reports.filters.transactionFrom"),
        type: 'dateField',
    },
    {
        fieldName: 'transaction_to',
        label: i18n.t("reports.filters.transactionTo"),
        type: 'dateField',
        minDateField: "transaction_from"
    },
    {
        fieldName: 'transaction_type',
        label: i18n.t("reports.filters.transaction_type"),
        type: 'multiSelect',
        dropDownOptionName: 'transactionTypes'
    },
    {
        fieldName: 'transaction_entered_by_user',
        label: i18n.t("reports.filters.transactionEnteredUser"),
        type: 'multiSelect',
        dropDownOptionName: 'praticeUserList'
    },
    {
        fieldName: "lab_sales_rep",
        type: "text",
        label: i18n.t("reports.filters.labSalesRep")
    },
    {
        fieldName: "clinic_site_name",
        type: "text",
        label: i18n.t("reports.filters.clinicSiteName")
    },
    {
        fieldName: "claim_service_type",
        type: "text",
        label: i18n.t("reports.filters.claimServiceType")
    },
    {
        fieldName: 'balance_type',
        label: i18n.t("reports.filters.balanceAmountTotals"),
        type: 'amountFilter',
        fieldPrefix: 'balanceAmountTotals',
    },
    {
        fieldName: 'aging',
        label: i18n.t("reports.filters.aging"),
        type: 'select',
        dropDownOptionName: 'agingList'
    }
].map(item => {
    if (!isValidFilterConfig(item)) {
        throw new Error(`Invalid filter config for ${item.fieldName}`);
    }
    return item;
})


export const creditBalanceFilterConfig = [
    {
        fieldName: "date_of_service_from",
        type: "dateField",
        label: i18n.t("reports.filters.dateOfServiceFrom")
    },
    {
        fieldName: "date_of_service_to",
        type: "dateField",
        label: i18n.t("reports.filters.dateOfServiceTo"),
        minDateField: "date_of_service_from"
    },
    {
        fieldName: "payment_entered_date_from",
        type: "dateField",
        label: i18n.t("reports.paymt_entered_dateRange_from")
    },
    {
        fieldName: "payment_entered_date_to",
        type: "dateField",
        label: i18n.t("reports.paymt_entered_dateRange_to"),
        minDateField: "payment_entered_date_from"
    },
    {
        fieldName: 'claim_status',
        label: i18n.t("reports.filters.claimStatus"),
        type: 'multiSelect',
        dropDownOptionName: 'claimStatusList'
    },
    {
        fieldName: 'rendering_provider',
        label: i18n.t("reports.filters.renderingProvider"),
        type: 'multiSelect',
        dropDownOptionName: 'renderingProviderList'
    },
    {
        fieldName: 'billing_provider',
        label: i18n.t("reports.filters.billingProvider"),
        type: 'multiSelect',
        dropDownOptionName: 'renderingProviderList'
    },
    {
        fieldName: 'primary_payer_ids',
        label: i18n.t("reports.filters.primary_insurance_payer"),
        type: 'multiSelect',
        dropDownOptionName: 'paymentPayerList'
    },
    {
        fieldName: 'secondary_payer_ids',
        label: i18n.t("reports.filters.secondary_insurance_payer"),
        type: 'multiSelect',
        dropDownOptionName: 'paymentPayerList'
    }
].map(item => {
    if (!isValidFilterConfig(item)) {
        throw new Error(`Invalid filter config for ${item.fieldName}`);
    }
    return item;
})


export const preBillingProductivityFilterConfig = [
    {
        fieldName: "action_date_from",
        type: "dateField",
        label: i18n.t("reports.filters.actionDateFrom"),
        isRequired: true
    },
    {
        fieldName: "action_date_to",
        type: "dateField",
        label: i18n.t("reports.filters.actionDateTo"),
        minDateField: "action_date_from",
        isRequired: true
    },
    {
        fieldName: "users",
        type: "multiSelect",
        label: i18n.t("reports.filters.users"),
        dropDownOptionName: "praticeUserList"
    }
].map(item => {
    if (!isValidFilterConfig(item)) {
        throw new Error(`Invalid filter config for ${item.fieldName}`);
    }
    return item;
})



            //Filters for each report
//-----------------------------------------------------------------------------//

export const transactionFilters={ 
    date_of_service_from: "",
    date_of_service_to: "",
    // dateOfPaymentEntry: "",
    // dateOfEntryFrom: "",
    // dateOfEntryTo: "",
    first_billed_date_from: "",
    first_billed_date_to: "",
    last_billed_date_from: "",
    last_billed_date_to: "",
    sample_received_date_from: "",
    sample_received_date_to: "",
    payer_type: [],
    insurance_company: [],
    claim_status: [],
    claim_sub_status: [],
    rendering_provider: [],
    reffering_provider: [],
    billing_provider: [],
    service_locations: [],
    cpt_code: [],
    icd: [],
    // chargeEnteredUser: [],
    // paymentEnteredUser: [],
    balance_type: "",
    balance_amount_start: "",
    balance_amount_end: "",
    aging: "",
    patient_ids: [],
    transaction_type: [],
    transaction_from: "",
    transaction_to: "",
    transaction_entered_by_user: [],
    lab_sales_rep : "",
    clinic_site_name: "",
    claim_service_type: ""
}

export const claimlevelFilters={
    // Date Range Filters
    date_of_service_from: "",
    date_of_service_to: "",
    first_billed_date_from: "",
    first_billed_date_to: "",
    last_billed_date_from: "",
    last_billed_date_to: "",
    sample_received_date_from: "",
    sample_received_date_to: "",
    transaction_from: "",
    transaction_to: "",

    // Multi-Select Lists
    patient_ids: [],
    payer_type: [],
    insurance_company: [],
    claim_status: [],
    claim_sub_status: [],
    rendering_provider: [],
    reffering_provider: [],
    billing_provider: [],
    service_locations: [],
    cpt_code: [],
    icd: [],
    transaction_type: [],
    transaction_entered_by_user: [],
    lab_sales_rep : "",
    clinic_site_name: "",
    claim_service_type: "",

    // Amount Range Filters (using the fieldPrefix from config)
    balance_type: "",
    balance_amount_start: "",
    balance_amount_end: "",

    // Other Filters
    aging: ""
}

export const chargesDebitFilters = { 
    dos_from: "",
    dos_to: "",
    date_of_entry_from: "",
    date_of_entry_to: "",
    first_billed_date_from: "",
    first_billed_date_to: "",
    last_billed_date_from: "",
    last_billed_date_to: "",
    sample_received_date_from: "",
    sample_received_date_to: "",
    payer_type: [],
    insurance_company: [],
    claim_status: [],
    claim_sub_status: [],
    rendering_provider: [],
    reffering_provider: [],
    billing_provider: [],
    service_locations: [],
    cpt_code: [],
    icd: [],
    charge_enter_user: [],
    payment_enter_user: [],
    balance_type: "",
    balance_amount_start: "",
    balance_amount_end: "",
    aging: "",
    lab_sales_rep : "",
    clinic_site_name: "",
    claim_service_type: ""
    
}

export const openArFilters = {
    date_of_service_from: "",
    date_of_service_to: "",
    date_of_entry_from: "",
    date_of_entry_to: "",
    first_billed_date_from: "",
    first_billed_date_to: "",
    last_billed_date_from: "",
    last_billed_date_to: "",
    sample_received_date_from: "",
    sample_received_date_to: "",
    payer_type: [],
    insurance_company: [],
    claim_status: [],
    claim_sub_tatus: [],
    rendering_provider: [],
    reffering_provider: [],
    billing_provider: [],
    service_locations: [],
    cpt_code: [],
    icd: [],
    balance_type: "",
    balance_amount_start: "",
    balance_amount_end: "",
    aging: "",
    lab_sales_rep : "",
    clinic_site_name: "",
    claim_service_type: ""
}

export const paymentAdjustmentsFilters={ 
    date_of_service_from: "",
    date_of_service_to: "",
    date_of_payment_entry_from: "", 
    date_of_payment_entry_to: "",
    date_of_entry_from: "",
    date_of_entry_to: "",
    first_billed_date_from: "",
    first_billed_date_to: "",
    last_billed_date_from: "",
    last_billed_date_to: "",
    sample_received_date_from: "",
    sample_received_date_to: "",
    payer_type: [],
    insurance_company: [],
    claim_status: [],
    claim_sub_status: [],
    rendering_provider: [],
    reffering_provider: [],
    billing_provider: [],
    serviceLocation: [],
    cpt_code: [],
    icd: [],
    charge_enter_user: [],
    payment_enter_user: [],
    balance_type: "",
    balance_amount_start: "",
    balance_amount_end: "",
    aging: "",
    payment_check_date_from : "",
    payment_check_date_to : "",
    payment_check_number: "",
    lab_sales_rep : "",
    clinic_site_name: "",
    claim_service_type: ""
    
}

export const checkLevelFilters={
    payment_check_date_from: "",
    payment_check_date_to: "",
    payment_entered_date_from: "",
    payment_entered_date_to: "",
    payment_modes: [],
    insurance_payer_ids: [],
    adjustment_type_ids: [],
    level_adjustment_condition: '',
    level_adjustment_start: '',
    level_adjustment_end: '',
    applied_amount_condition: '',
    applied_amount_start: '',
    applied_amount_end: '',
    unapplied_amount_condition: '',
    unapplied_amount_start: '',
    unapplied_amount_end: '',
    lab_sales_rep : "",
    clinic_site_name: "",
    claim_service_type: ""
}
export const priorAuthFilters={
    valid_auth_from: "",
    valid_auth_to:"",
    insurance_company: [],
    patient_ids:[],
    visit_remaining_min:"",
    visit_remaining_max:"",
    cpt_code: [],
    icd: [],
}

export const denialFilters={
    // Date Range Filters
    date_of_service_from: "",
    date_of_service_to: "",
    date_of_payment_entry_from: "",
    date_of_payment_entry_to: "",
    date_of_entry_from: "",
    date_of_entry_to: "",
    payment_check_date_from: "",
    payment_check_date_to: "",
    first_billed_date_from: "",
    first_billed_date_to: "",
    last_billed_date_from: "",
    last_billed_date_to: "",
    sample_received_date_from: "",
    sample_received_date_to: "",

    // List Selection Filters
    insurance_company: [],
    claim_status: [],
    claim_sub_status: [],
    rendering_provider: [],
    referring_provider: [],
    billing_provider: [],
    cpt_code: [],
    denial_code: [],
    service_locations: [],

    // Amount Range Filters
    balance_type: "",
    balance_amount_start: "",
    balance_amount_end: "",

    charge_amount_condition: "",
    charge_amount_start: "",
    charge_amount_end: "",

    // Other Filters
    aging: "",
    lab_sales_rep : "",
    clinic_site_name: "",
    claim_service_type: ""
}


export const creditBalanceFilter={
    date_of_service_from: "",
    date_of_service_to: "",
    date_of_payment_entry_from: "",
    date_of_payment_entry_to: "",
    billing_provider: [],
    rendering_provider: [],
    primary_payer_ids:[],
    secondary_payer_ids:[],
    claim_status: []
}

export const preBillingProductivityFilters = {
    action_date_from: "",
    action_date_to: "",
    users: []
};